import React, { useState } from 'react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

const FormInput = ({
  inputType,
  placeholder,
  name,
  type,
  className,
  inputValue,
  min,
  max,
  change,
  blur,
  title,
  id,
  error,
  touched,
  passwordShow,
  readonly
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={className}>
      {inputType ? (
        <label tabIndex="0" className="relative focus:outline-none" htmlFor={name}>
          <input
            className={`w-full px-3 py-4 bg-gray-200 border-b ${
              touched && inputValue && inputValue.length === 0 ? 'border-red-700' : 'border-cf-300'
            } focus:outline-none leading-tight text-sm text-gray-700`}
            placeholder={placeholder}
            type={showPassword ? 'text' : type}
            id={id}
            minLength={min}
            maxLength={max}
            name={name}
            value={inputValue}
            onChange={change}
            onBlur={blur}
            readOnly={readonly}
          />
          <span className="absolute left-0 top-0 pl-3 text-xs focus-within:mt-0 -mt-5 text-gray-600">
            {title}
          </span>

          {passwordShow ? (
            <span
              onClick={handleShowPassword}
              className="absolute right-0 bottom-0 mr-2 text-sm text-cf-300 focus-within:hidden"
            >
              {showPassword ? <MdVisibility title="hide" /> : <MdVisibilityOff title="show" />}
            </span>
          ) : null}
        </label>
      ) : (
        <label className="relative" htmlFor={name}>
          <textarea
            className="w-full p-2 bg-gray-200 border-b-2 border-cf-300 focus:outline-none leading-tight appearance-none text-gray-700"
            placeholder={placeholder}
            name={name}
            id={id}
            value={inputValue}
            onChange={change}
            onBlur={blur}
            readOnly={readonly}
          ></textarea>
          <span className="absolute left-0 top-0 pl-3 text-xs focus-within:mt-0 -mt-12 text-gray-600">
            {title}
          </span>
        </label>
      )}
      {error && touched ? <p className="text-xs text-red-700">{error}</p> : null}
    </div>
  );
};

export default FormInput;
